<!-- 积分商城配置 -->
<template>
  <div class='content'>
    <el-form ref="form" label-width="auto" align="left" :inline="true">
      <el-form-item label="商品名称：">
        <el-input placeholder="请输入商品名称" @change="getTableList()" v-model="params.prizeName"></el-input>
      </el-form-item>
      <el-form-item label="状态：">
        <el-select v-model="params.isDelete">
          <el-option value="" label="全部"></el-option>
          <el-option :value="0" label="启用"></el-option>
          <el-option :value="1" label="禁用"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="getTableList()">搜索</el-button>
        <el-button size="small" @click="resetParams();getTableList();">重置</el-button>
        <el-button size="small" type="primary" @click="getProductList();resetForm();title='新增';dialogVisible=true">新增</el-button>
        <!-- <el-button size="small" @click="">兑换规则</el-button> -->
      </el-form-item>
    </el-form>

    <el-table 
      :data="tableData"
      class="mt-20"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}">
      <el-table-column label="商品名称" prop="prizeName"></el-table-column>
      <el-table-column label="兑换积分" prop="prizeValue"></el-table-column>
      <el-table-column label="排序" prop="prizeOrder"></el-table-column>
      <el-table-column label="兑换限制">
        <template slot-scope="scope">
          <span v-if="scope.row.totalLimit<=0">无限制</span>
          <span v-else>{{ scope.row.perLimit }}次/人</span>
        </template>
      </el-table-column>
      <el-table-column label="初始已兑换数量" prop="initStock"></el-table-column>
      <el-table-column label="兑换总数">
         <template slot-scope="scope">
          {{ scope.row.usedStock+scope.row.prizeStock }}
         </template>
      </el-table-column>
      <el-table-column label="已兑换数量" prop="usedStock"></el-table-column>
      <el-table-column label="奖品剩余数量" prop="prizeStock"></el-table-column>
       <el-table-column label="状态" prop="isDeleted">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isDeleted"
            @change="switchStatus(scope.row)"
            :active-value="0"
            :inactive-value="1"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button 
            type="text" 
            size="small" 
            @click="update(scope.row)">编辑</el-button>
          <el-button 
            type="text" 
            size="small" 
            v-if="scope.row.prizeType == 1"
            @click="openInventory(scope.row)">同步库存</el-button>
          <el-button 
            type="text" 
            size="small" 
            @click="openWarning(scope.row)">库存预警</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-row class="mt-15 mr-20 text-right" v-if="total > 0">
      <el-pagination 
        small 
        layout="total,prev,pager,next,sizes,jumper"
        :page-size="params.pageSize"
        :total="total" 
        :current-page.sync="params.pageNum" 
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-row>

    <!-- 新增/编辑 -->
    <el-dialog :title="title" top="20px" :visible.sync="dialogVisible"> 
      <el-form :model="form" ref="form" :rules="rules" label-width="auto">
        <el-form-item label="商品名称：" prop="productId">
          <el-select style="width: 100%" v-model="form.productId" placeholder="请选择商品" filterable clearable>
            <el-option v-for="i in productList" :key="i.productId" :value="i.productId" :label="i.productName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="兑换积分：" prop="prizeValue">
          <el-input type="text" v-model="form.prizeValue" placeholder="请输入兑换积分"></el-input>
        </el-form-item>
        <el-form-item label="排序：" prop="prizeOrder">
          <el-input type="text" v-model="form.prizeOrder" placeholder="请输入排序"></el-input>
        </el-form-item>
        <el-form-item label="兑换总数：" required>
          <el-input type="text" v-model="form.prizeStock" placeholder="请输入兑换总数"></el-input>
        </el-form-item>
        <el-form-item label="初始已兑换数量：">
          <el-input type="text" v-model="form.initStock" placeholder="请输入初始已兑换数量"></el-input>
        </el-form-item>
        <el-form-item label="兑换限制：" required>
          <el-radio-group v-model="radio">
            <el-radio :label="1">无限制</el-radio>
            <el-radio :label="2">限制总次数</el-radio>
            <el-radio :label="3">限制总次数+频率</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="兑换总数：" v-if="radio==2" required>
          <el-input type="text" v-model="form.totalLimit" placeholder="请输入兑换总数"></el-input>
        </el-form-item>
        <el-form-item label="限制次数+频率：" v-if="radio==3" required>
          <div style="display: flex;align-items: center;">
            <el-input type="text" style="width: 160px;" v-model="form.totalLimit" placeholder="请输入次数"></el-input>&nbsp; 次 &nbsp;
            <el-input type="text" style="width: 160px;" v-model="form.perLimit" placeholder="请输入天数"></el-input>&nbsp; 天/人
          </div>
        </el-form-item>
        <el-form-item label="商品详情：" prop="prizeDetail">
          <vue-ueditor-wrap v-model="form.prizeDetail" :config="myConfig"></vue-ueditor-wrap>
        </el-form-item>
      </el-form>
      <el-row class="text-right mt-20">
        <el-button @click="resetForm();dialogVisible=false;title='';">取消</el-button>
        <el-button type="primary" :loading="buttonLoading" @click="confirm()">确定</el-button>
      </el-row>
    </el-dialog>

    <!-- 库存预警 -->
    <el-dialog :title="warning.title" top="20px" :visible.sync="warning.visible"> 
      <el-form :model="form" ref="warningForm" :rules="warningRules" label-width="auto">
        <el-form-item label="预警商品：">{{ warningProductName }}</el-form-item>
        <el-form-item label="预警门槛：" prop="stockWarn">
          <el-input type="text" v-model="form.stockWarn" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="预警手机号：" prop="warnMobile">
          <el-input type="text" v-model="form.warnMobile" placeholder="请输入预警手机号用 ,分割"></el-input>
        </el-form-item>
      </el-form>
      <el-row class="text-right mt-20">
        <el-button @click="resetForm();warning.title='';warning.visible=false">取消</el-button>
        <el-button type="primary" :loading="buttonLoading" @click="confirmWarning()">确定</el-button>
      </el-row>
    </el-dialog>

    <!-- 同步库存 -->
    <el-dialog title="同步库存" top="20px" :visible.sync="visibleInventory"> 
      <el-form label-width="auto">
        <el-form-item label="商品名称：">{{ warningProductName }}</el-form-item>
        <el-form-item label="剩余库存：">{{ inventoryNum }}</el-form-item>
      </el-form>
      <el-table 
        :data="inventoryData"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}">
        <el-table-column label="序号" prop="stockId"></el-table-column>
        <el-table-column label="cdKey" prop="cdkeyCode"></el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-row class="mt-15 mr-20 text-right" v-if="total > 0">
        <el-pagination  
          :page-size="inventoryParams.pageSize"
          :total="inventoryTotal" 
          :current-page.sync="inventoryParams.pageNum" 
          :page-sizes="[10 ,20 , 30, 40, 50]"
          @size-change="handleSizeChangeInventory" 
          @current-change="handleCurrentChangeInventory">
        </el-pagination>
      </el-row>
      <el-row class="text-center mt-20">
        <el-button type="primary" @click="visibleInventory=false;withdrawVisible=true;">库存提取</el-button>
        <el-button type="primary" @click="visibleInventory=false;dialogVisibleBatch=true;formBatch.file=''">库存同步</el-button>
      </el-row>
    </el-dialog>

    <!-- 提取 -->
    <el-dialog title="提取" top="20px" width="400px" :visible.sync="withdrawVisible"> 
      <el-form :model="withdrawForm" ref="withdrawForm" :rules="withdrawRules" label-width="auto">
        <el-form-item label="提取数量：" prop="extractNum">
          <el-input type="text" v-model="withdrawForm.extractNum" placeholder="请输入提取数量"></el-input>
        </el-form-item>
      </el-form>
      <el-row class="text-right mt-20">
        <el-button @click="resetWithdrawForm();withdrawVisible=false">取消</el-button>
        <el-button type="primary" :loading="buttonLoading" @click="confirmWithdraw()">确定</el-button>
      </el-row>
    </el-dialog>

    <el-dialog title="库存同步" top="20px" width="500px" :visible.sync="dialogVisibleBatch"> 
      <el-form :model="formBatch" ref="formBatch" label-width="auto">
        <el-form-item label="上传文件：" required="">
          <el-upload
            class="upload-demo"
             action="" :http-request="importExcel" :show-file-list="false">
            <el-button v-if="!formBatch.file" size="small" type="primary">点击上传</el-button>
            <span v-if="formBatch.file">{{ formBatch.file.name }}</span>
            <el-button v-if="formBatch.file" size="small" type="primary" style="margin-left: 5px;">重新上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div style="font-size: 12px;padding-left: 80px;color: #4200ff;cursor: pointer;" @click="exportExcel">下载模板</div>
      <el-row class="text-right mt-20">
        <el-button @click="formBatch.file='';dialogVisibleBatch=false">取消</el-button>
        <el-button type="primary" :loading="buttonLoading" @click="confirmBatch()">确定</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
 
<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  import VueUeditorWrap from 'vue-ueditor-wrap';
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {VueUeditorWrap},
    //ComponentName和文件名保持一致
    name:'pointsStore',
    data() {
      //这里存放数据
      return {
        params:{
          prizeName:'',
          isDelete:'',
          page:1,
          pageSize:10
        },
        tableData:[],
        total:0,
        productList:[],
        title:'',
        dialogVisible:false,
        form:{
          prizeId: null,
          productId:  '',
          prizeValue: '',
          prizeOrder: '',
          prizeStock: '',
          usedStock: '',
          totalLimit: 0,
          perLimit: '',
          unitLimit: 1, // 0-小时 1-天 2-周 3-月 4-季
          prizeDetail: '',
          stockWarn: '',
          warnMobile: '',
          isDeleted: '0' //0:启用 1:禁用
        },
        rules:{
          productId: [{ required: true, message: "请选择商品", trigger: "blur" }],
          prizeValue: [{ required: true, message: "请选择兑换积分", trigger: "blur" }],
          prizeOrder: [{ required: true, message: "请输入排序", trigger: "blur" }],
          prizeDetail: [{ required: true, message: "请输入商品详情", trigger: "blur" }],
        },
        radio:1,
        buttonLoading:false,
        myConfig: {
          // 编辑器不自动被内容撑高
          autoHeightEnabled: false,
          // 初始容器高度
          initialFrameHeight: 240,
          // 初始容器宽度
          initialFrameWidth: '100%',
          // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
          //serverUrl: 'http://35.201.165.105:8000/controller.php',
          serverUrl: this.ajax.baseUrl + 'oss/editorResources',
          // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
          UEDITOR_HOME_URL: '/static/UEditor/'
        },
        warning:{
          title:'库存预警',
          visible:false,
        },
        warningRules: {
          stockWarn: [{ required: true, message: "请输入预警门槛", trigger: "blur" }],
          warnMobile: [{ required: true, message: "请输入预警手机号", trigger: "blur" }]
        },
        warningProductName: '',
        inventoryNum:'',
        visibleInventory: false,
        inventoryParams: {
          pageNum: 1,
          pageSize: 10,
          prizeId: '',
          isPage: true
        },
        inventoryData: [],
        inventoryTotal: 0,
        withdrawVisible: false,
        withdrawForm: {
          prizeId:'',
          extractNum:''
        },
        withdrawRules:{
          extractNum:[{ required: true, message: "请输入提取数量", trigger: "blur" }]
        },
        dialogVisibleBatch: false,
        formBatch: {
          file:{},
          prizeId: '',
          productId: ''
        },
        rowData:{}
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      getTableList(){
        this.ajax.fetch({
          url: this.apis.pointsStore.get,
          disableLoading: true,
          method: 'post',
          param: this.params,
          successFunc: res=>{
            this.total = res.total;
            this.tableData = res.result;
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      importExcel(file) {
        let index1 = file.file.name.lastIndexOf(".");
        let index2 = file.file.name.length;
        let postf = file.file.name.substring(index1, index2);//后缀名
        if (postf.indexOf('xlsx') === -1 && postf.indexOf('xls') === -1) {
          this.toast.showWarning('只能上传excel文件');
          return;
        }
        this.formBatch.file = file.file;
      },
      confirmBatch(){
        if(!this.formBatch.file) return this.$message.error('请选择文件');
        this.formBatch.prizeId = this.rowData.prizeId;
        this.formBatch.productId = this.rowData.productId;
        this.ajax.upload({
          url: this.apis.pointsStore.import,
          param: this.formBatch,
          successFunc: res => {
            this.$message.success('同步成功');
            this.dialogVisibleBatch = false;
            this.formBatch.file = '';
            this.getTableList();
          },
          errorFunc: res => {
            this.$message.error(res.info);
          }
        })
      },
      exportExcel(){
        this.ajax.downLoad(this.apis.netBarAccountManage.downLoad , {templateName:'cdKey'});
      },
      confirmWithdraw(){
        this.withdrawForm.prizeId = this.inventoryParams.prizeId;
        this.$refs.withdrawForm.validate(valid => {
          if (valid) {
            this.ajax.fetch({
              url: this.apis.pointsStore.extractCdKey,
              disableLoading: true,
              method: 'post',
              param: this.withdrawForm,
              successFunc: res=>{
                this.$message.success('提取成功!');
                this.withdrawVisible = false;
                this.resetWithdrawForm();
                this.tableData();
              },
              errorFunc: err=>{
                this.$message.error(err.info);
              }
            });
          } else {
            return false;
          }
        });
      },
      resetWithdrawForm(){
        this.withdrawForm = {
          prizeId:'',
          extractNum:''
        };
      },
      openInventory(row){
        this.rowData = row;
        this.inventoryNum = row.prizeStock;
        this.warningProductName = row.prizeName;
        this.inventoryParams.prizeId = row.prizeId;
        this.inventoryParams.pageNum = 1;
        this.inventoryParams.pageSize = 5;
        this.getSyncStockCdKeyList();
      },
      getSyncStockCdKeyList(){
        this.ajax.fetch({
          url: this.apis.lotteryActivityTaskPrizes.getSyncStockCdKeyList,
          disableLoading: true,
          method: 'post',
          param: this.inventoryParams,
          successFunc: res=>{
            this.inventoryTotal = res.total;
            this.inventoryData = res.result;
            this.visibleInventory = true;
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      openWarning(row){
        this.warning.title = '库存预警';
        this.warning.visible = true;
        this.assignmentForm(row);
        this.warningProductName = row.prizeName;
      },
      confirmWarning(){
        this.$refs.warningForm.validate(valid => {
          if (valid) {
            this.ajax.fetch({
              url: this.apis.pointsStore.stockWarn,
              disableLoading: true,
              method: 'post',
              param: this.warningForm,
              successFunc: res=>{
                this.$message.success('预警成功!');
                this.warning.visible = false;
                this.getTableList();
              },
              errorFunc: err=>{
                this.$message.error(err.info);
              }
            });
          } else {
            return false;
          }
        });
      },
      assignmentForm(row){
        this.form.prizeId = row.prizeId;
        this.form.productId = row.productId;
        this.form.prizeValue = row.prizeValue;
        this.form.prizeOrder = row.prizeOrder;
        this.form.prizeStock = row.prizeStock;
        this.form.usedStock = row.usedStock;
        this.form.totalLimit = row.totalLimit;
        this.form.perLimit = row.perLimit;
        this.form.unitLimit = row.unitLimit;
        this.form.prizeDetail = row.prizeDetail;
        this.form.stockWarn = row.stockWarn;
        this.form.warnMobile = row.warnMobile;
        this.form.isDeleted = row.isDeleted;
      },
      update(row){
        this.getProductList();
        this.title = '编辑';
        this.assignmentForm(row);
        if (this.form.totalLimit <= 0) {
          this.radio = 1;
        }else if(this.form.totalLimit > 0 && this.form.perLimit <= 0) {
          this.radio = 2;
        }else{
          this.radio = 3;
        }
        this.dialogVisible = true;
      },
      confirm(){
        if (this.radio == 2) {
          if (!this.form.totalLimit) return this.$message.error('兑换总数不能为空');
        }else if(this.radio == 3) {
          if (!this.form.totalLimit || !this.form.perLimit) return this.$message.error('限制次数和频率都不能为空');
        }
        this.$refs.form.validate(valid => {
          if (valid) {
            this.buttonLoading = true;
            let url = this.form.prizeId != null ? this.apis.pointsStore.update : this.apis.pointsStore.add;
            this.ajax.fetch({
              url: url,
              disableLoading: true,
              method: 'post',
              param: this.form,
              successFunc: res=>{
                this.getTableList();
                this.resetForm();
                this.$message.success('操作成功！');
                this.dialogVisible = false;
                this.buttonLoading = false;
                this.radio = 1;
              },
              errorFunc: err=>{
                this.buttonLoading = false;
                this.$message.error(err.info);
              }
            });
          } 
        });
      },
      switchStatus(row){
        this.assignmentForm(row);
        this.ajax.fetch({
          url: this.apis.pointsStore.update,
          disableLoading: true,
          method: 'post',
          param: this.form,
          successFunc: res=>{
            this.getTableList();
            this.resetForm();
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      resetForm(){
        this.form = {
          prizeId: null,
          productId:  '',
          prizeValue: '',
          prizeOrder: '',
          prizeStock: '',
          usedStock: '',
          totalLimit: 0,
          perLimit: '',
          unitLimit: 1, // 0-小时 1-天 2-周 3-月 4-季
          prizeDetail: '',
          stockWarn: '',
          warnMobile: '',
          isDeleted: '0' //0:启用 1:禁用
        }
      },
      resetParams(){
        this.params = {
          prizeName:'',
          isDelete:'',
          page:1,
          pageSize:10
        }
      },
      getProductList(){
        this.ajax.fetch({
          url: this.apis.goodsManage.get,
          disableLoading: true,
          method: 'post',
          param: {
            productName: '',
            productType: '',
            pageNum: 1,
            pageSize: 999
          },
          successFunc: res=>{
            this.productList = res.result;
          },
          errorFunc: err=>{
            this.$message.error(err.info);
          }
        });
      },
      handleSizeChange(page) {
        this.params.pageSize = page;
        this.getTableList();
      },
      handleCurrentChange(val){
        this.params.pageNum = val;
        this.getTableList();
      },
      handleSizeChangeInventory(page) {
        this.inventoryParams.pageSize = page;
        this.getSyncStockCdKeyList();
      },
      handleCurrentChangeInventory(val){
        this.inventoryParams.pageNum = val;
        this.getSyncStockCdKeyList();
      },
    },
    beforeCreate() {}, //生命周期 - 创建之前
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    beforeMount() {}, //生命周期 - 挂载之前
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.getTableList();
    },
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    deactivated() {}, //如果页面有keep-alive缓存功能，当组件被移除时，触发钩子函数deactivated
  }
</script>

<style lang='scss' scoped>

</style>


// WEBPACK FOOTER //
// src/page/activityManage/pointsStore/pointsStore.vue